/**
 * Model used to hold a paged response. This allows us to
 * to fetch more results using the page urls.
 */
export class PagedResponse {
    public firstPageUrl: string;
    public lastPageUrl: string;
    public previousPageUrl: string;
    public nextPageUrl: string;
    public totalCount: number;
    public recordList: any[] = [];

    constructor(
        firstPageUrl?: string,
        lastPageUrl?: string,
        previousPageUrl?: string,
        nextPageUrl?: string,
        totalCount?: number,
        recordList?: any[],
    ) {
        this.firstPageUrl = firstPageUrl || null;
        this.lastPageUrl = lastPageUrl || null;
        this.previousPageUrl = previousPageUrl || null;
        this.nextPageUrl = nextPageUrl || null;
        this.totalCount = totalCount || 0;
        this.recordList = recordList || [];
    }

    get canLoadMore(): boolean {
        return this.nextPageUrl !== null;
    }

    public clone(): PagedResponse {
        const clone: PagedResponse = new PagedResponse(
            this.firstPageUrl,
            this.lastPageUrl,
            this.previousPageUrl,
            this.nextPageUrl,
            this.totalCount,
            [],
        );

        if (this.recordList) {
            clone.recordList = this.recordList.map((rec: any) => rec.clone());
        }

        return clone;
    }
}

export interface IPagedResponse {
    links: {
        first?: string;
        prev?: string;
        last?: string;
        next?: string;
    };
    data: any[];
    included?: any[];
    meta: {
        total: number;
    };
    jsonapi: {
        version: string;
    };
}
